import bookTemplate from 'book.template/main.js';

$(()=>{

bookTemplate();

$('html').addClass('book-js-loaded');
});